export default {"src":"/_next/static/media/pair-2.bda53025.svg","height":342,"width":455,"blurWidth":0,"blurHeight":0};